import { ActionIcon, Avatar } from '@mantine/core';
import type { ActionIconProps } from '@mantine/core';
import styled from 'styled-components';

const TableDeleteButton = ({ onClick }: any) => {
  return (
    <div onClick={onClick}>
      <StyledActionIcon radius={50} size={40}>
        <Avatar src={'/assets/deleteIcon.png'} radius={0} size={24} />
      </StyledActionIcon>
    </div>
  );
};
export default TableDeleteButton;

const StyledActionIcon = styled(ActionIcon)<ActionIconProps>`
background: transparent;
  &:hover {
    background: #FFE8E9;
  }
`;
